import React, { useState } from "react";
import { Link } from "react-scroll";

export default function BarreNavigation() {
  const [menuOpen, setMenuOpen] = useState(false);

  const liens = [
    { to: "accueil", label: "Accueil" },
    { to: "apropos", label: "À propos" },
    { to: "services", label: "Services" },
    { to: "projets", label: "Projets" },
    { to: "contact", label: "Contact" },
  ];

  return (
    <nav className="fixed w-full top-0 z-50 backdrop-blur-md bg-white/80 shadow-md transition-all duration-300">
      <div className="flex items-center justify-between px-6 md:px-12 py-4">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <img
            src="/images/logo.png"
            alt="Logo Virtuo Systems Maroc"
            className="w-10 h-10 object-contain"
          />
          <span className="text-lg md:text-xl font-bold text-[#0F172A]">
            Virtuo Systems Maroc
          </span>
        </div>

        {/* Liens desktop */}
        <ul className="hidden md:flex space-x-8 text-[#0F172A] font-medium">
          {liens.map((lien) => (
            <li key={lien.to} className="relative group">
              <Link
                to={lien.to}
                spy={true}
                smooth={true}
                offset={-80}
                duration={700}
                activeClass="active-link"
                className="cursor-pointer hover:text-[#2563EB] transition duration-200"
                onClick={() => setMenuOpen(false)}
              >
                {lien.label}
              </Link>
              {/* Barre soulignée animée */}
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-[#2563EB] transition-all duration-300 group-hover:w-full"></span>
            </li>
          ))}
        </ul>

        {/* Menu mobile */}
        <button
          className="md:hidden text-[#0F172A] focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? "✖" : "☰"}
        </button>
      </div>

      {/* Menu mobile déroulant */}
      {menuOpen && (
        <div className="md:hidden bg-white/95 shadow-lg border-t border-gray-200">
          <ul className="flex flex-col items-center py-4 space-y-3 text-[#0F172A] font-medium">
            {liens.map((lien) => (
              <li key={lien.to}>
                <Link
                  to={lien.to}
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={700}
                  activeClass="active-link"
                  className="cursor-pointer hover:text-[#2563EB] transition duration-200"
                  onClick={() => setMenuOpen(false)}
                >
                  {lien.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}
